// extracted by mini-css-extract-plugin
module.exports = {"CardPattern":"CardPattern_CardPattern__1UA58","CardPattern__item":"CardPattern_CardPattern__item__3AqZa","CardPattern__figure":"CardPattern_CardPattern__figure__3bBAl"};